import styled from "styled-components";
import Button from "../Button/Button";

interface InputWrapperProps {
  $type?: "number";
}

export const InputWrapper = styled("div")<InputWrapperProps>`
  position: relative;
  width: 100%;
  margin-right: 10px;
  margin-bottom: 20px;

  input {
    width: 100%;
    padding-right: ${(props) => (props.$type === "number" ? "14px" : "36px")};
  }

  ${(props) => props.theme.sm`
    margin: 0 0 10px 0;
  `}
`;

export const SearchButton = styled(Button)`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  padding: 0 10px 0 5px;
  display: flex;
  align-items: center;

  .icon {
    height: 15px;
    width: 15px;
    transition: background-color 0.3s;
  }

  &:hover .icon {
    background-color: ${(props) => props.theme.primary};
  }
`;
